import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { HeroCardCarouselBlockConfig } from '@front-platform/content-builder';
import { heroCardCarouselBlockResolveConfig } from '@front-platform/content-builder';
import { Component, HostBinding, input, computed } from '@angular/core';

import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
export interface HeroCardCarouselBlockRuntimeConfig {}

export type HeroCardCarouselBlockConfigInput = Partial<
  Omit<HeroCardCarouselBlockConfig, keyof HeroCardCarouselBlockRuntimeConfig> &
    HeroCardCarouselBlockRuntimeConfig
>;
export type HeroCardCarouselBlockResolvedConfig = Omit<
  HeroCardCarouselBlockConfig,
  keyof HeroCardCarouselBlockRuntimeConfig
> &
  Partial<HeroCardCarouselBlockRuntimeConfig>;
export interface HeroCardCarouselBlockContract extends ConfigComponentContract<
  HeroCardCarouselBlockConfigInput,
  HeroCardCarouselBlockResolvedConfig
> {}

@Component({
  selector: 'app-hero-card-carousel-block',
  templateUrl: './hero-card-carousel-block.component.html',
  standalone: false,
})
export class HeroCardCarouselBlockComponent implements HeroCardCarouselBlockContract {
  readonly config = input<HeroCardCarouselBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    HeroCardCarouselBlockConfig,
    HeroCardCarouselBlockRuntimeConfig
  >(heroCardCarouselBlockResolveConfig, () => ({ config: this.config() }));
  readonly backgroundImage = computed(
    () => this.resolvedConfig()['background_image'] as unknown as string,
  );
  readonly linkUrl = computed(() => this.resolvedConfig()['link_url'] as unknown as string);
  readonly linkTarget = computed(() => this.resolvedConfig()['link_target'] as unknown as string);
  readonly heading = computed(() => this.resolvedConfig()['heading'] as unknown as string);
  readonly content = computed(() => this.resolvedConfig()['content'] as unknown as string);
  readonly textColor = computed(
    () => this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor,
  );
  readonly backgroundColor = computed(
    () => this.resolvedConfig()['background_color'] as unknown as IContentBuilderFieldColor,
  );

  @HostBinding('class') protected readonly classes = 'h-64 w-52 max-w-52 min-w-52 p-1';
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(HeroCardCarouselBlockComponent, { 'keyAliases': {} });
